export default {"src":"/_next/static/media/instagram.c6c17339.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};